import { apiClient } from '../lib/api/client';

const API_BASE = '/api/v1/public';

export const getPublicPackages = async () => {
    try {
        const response = await apiClient.get(`${API_BASE}/packages`);
        return response.data;
    } catch (error) {
        console.error('Error fetching public packages:', error);
        throw error;
    }
};
